import React from 'react';
import OrganizationView from './OrganizationView';

export const OrganizationContainer = () => {
  return (
    <div>
      <OrganizationView />
    </div>
  );
};
